export default (function (parentElement, element) {
    for (var i = 0; i < parentElement.children.length; i++) {
        if (parentElement.children[i] == element) {
            return i;
        }
    }
    return -1;
});
